<template>
  <transition-group 
    tag="div" 
    class="message-container"
    name="message"
  >
    <div
      v-for="msg in messages"
      :key="msg.id"
      class="message"
      @click="handleClick(msg)"
    >
      <div class="message-content">
        <div class="message-header">
          <span class="task-id"> {{ msg.title }}</span>
          <span class="task-status" :class="msg.status">{{ getStatusText(msg.status) }}</span>
        </div>
        <div class="message-body">
          <i class="el-icon-bell"></i>
          <span>{{ msg.message }}</span>
        </div>
        <div class="message-progress" v-if="msg.progress">
          <div class="progress-bar" :style="{ width: msg.progress + '%' }"></div>
          <span class="progress-text">{{ msg.progress }}%</span>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: 'MessageNotification',
  
  data() {
    return {
      messages: []
    }
  },

  methods: {
    // 添加消息
    addMessage(message) {
      const msg = {
        id: Date.now(),
        title: message.title,
        status: message.status,
        message: message.message,
        progress: message.progress,
        route: message.route
      }
      this.messages.push(msg)
      
      // 10秒后自动移除
      setTimeout(() => {
        this.removeMessage(msg.id)
      }, 10000)
    },

    getStatusText(status) {
      const statusMap = {
        pending: '等待中',
        processing: '处理中',
        completed: '已完成',
        failed: '失败'
      }
      return statusMap[status] || status
    },

    // 移除消息
    removeMessage(id) {
      const index = this.messages.findIndex(msg => msg.id === id)
      if (index > -1) {
        this.messages.splice(index, 1)
      }
    },

    // 点击消息跳转
    handleClick(msg) {
      if (msg.route) {
        this.$router.push(msg.route)
      }
      this.removeMessage(msg.id)
    }
  }
}
</script>

<style scoped>
.message-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.message {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 16px;
  width: 360px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s;
  transform-origin: top right;
}

.message:hover {
  transform: scale(1.02);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.task-id {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
}

.task-status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.task-status.pending {
  background: rgba(99, 102, 241, 0.15);
  color: var(--accent-color);
}

.task-status.processing {
  background: rgba(234, 179, 8, 0.15);
  color: #EAB308;
}

.task-status.completed {
  background: rgba(34, 197, 94, 0.15);
  color: #22C55E;
}

.task-status.failed {
  background: rgba(239, 68, 68, 0.15);
  color: #EF4444;
}

.message-body {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.5;
}

.message-body i {
  font-size: 18px;
  color: var(--accent-color);
}

.message-progress {
  margin-top: 12px;
  background: var(--bg-tertiary);
  border-radius: 6px;
  height: 6px;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, var(--accent-color) 0%, #818cf8 100%);
  border-radius: 6px;
  transition: width 0.3s ease;
}

.progress-text {
  position: absolute;
  right: 0;
  top: -20px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}

/* 优化动画效果 */
.message-enter-active {
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.message-leave-active {
  transition: all 0.3s ease;
}

.message-enter,
.message-leave-to {
  opacity: 0;
  transform: translateX(30px) scale(0.95);
}
</style> 